/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
// import { useRouter } from 'next/router';

import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../../../components/atoms/loader";
import FormContainer from "../../../components/atoms/forms/formContainer";
import FileUpload from "../../../components/atoms/fileUpload";
import SelectAndCreate from "../../../components/select/SelectAndCreate";
import CreateHistory from "./createHistory";
// import Search from "../../../components/select/Search";
import { Switch } from '@headlessui/react'

import Axios from "../../../AxiosConfig";
import { useStore } from "../../../store";
import FileViewer from "../../../components/atoms/fileViewer";
import { useForm } from "react-hook-form";
import { regex } from "../../../utils/regexPaterns";
import ImageFileUpload from "../../../components/atoms/imagefileUpload";
import ImageCropingViewer from "../../../components/atoms/imageCroping";
import PencilIcon from "../../../components/theme/pencilIcon";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const CreateEmployee = () => {
    let mode = "create";
    const [loading, setLoading] = useState(false);
    // const router = useRouter();

    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const [enabled, setEnabled] = useState([false, true, true, true, true, true, false])
    const [numberOfLeaves, setNumberOfLeaves] = useState(0)
    const [timePeriod, setTimePeriod] = useState("weekly")
    const [startMonth, setStartMonth] = useState(1);

    const { layoutStore, employeeStore } = useStore();
    const navigate = useNavigate();
    const location = useLocation();
    if (location.pathname.includes("edit")) {
        mode = "edit";
    }
    const [data, setData] = useState({});
    const today = new Date();
    var two_days_in_future = new Date();
    two_days_in_future.setDate(two_days_in_future.getDate() + 2)
    var dob_max = (today.getFullYear() - 14).toString();
    var dob_min = (today.getFullYear() - 100).toString();
    var past_100_year = (today.getFullYear() - 100).toString();
    var now_year = (today.getFullYear()).toString();
    var next_year = (today.getFullYear() + 1).toString();
    var next_ten_year = (today.getFullYear() + 10).toString();
    var now_month = today.getMonth() + 1;
    if (now_month < 10) {
        now_month = "0" + now_month.toString()
    }
    else {
        now_month = now_month.toString()
    }
    var now_date = today.getDate()
    if (now_date < 10) {
        now_date = "0" + now_date.toString()
    }
    else {
        now_date = now_date.toString()
    }
    // Inputs
    const [department, setDepartment] = useState(null);
    const [designation, setDesignation] = useState(null);
    const [workLocation, setWorkLocation] = useState(null);
    const [sourceOfHiring, setSourceOfHiring] = useState(null);
    const [citizenship, setCitizenship] = useState(null);
    const [showVisaInputBox, setShowVisaInputBox] = useState(false);
    const [otherVisa, setOtherVisa] = useState(null);
    // const [createEmployeeSubmit, setCreateEmployeeSubmit] = useState('');
    // Checks
    const [officialEmail, setOfficialEmail] = useState(null);
    const [officialEmailText, setOfficialEmailText] = useState("Check Availability");
    // Documents
    const [rightToWork, setRightToWork] = useState(null);

    const [employementContract, setEmployementContract] = useState(null);
    const [skillQualification, setSkillQualification] = useState(null);
    const [recruitmentProcess, setRecruitmentProcess] = useState(null);
    const [otherDocuments, setOtherDocuments] = useState(null);
    const [hideExtraLoading, setHideExtraLoading] = useState(false);
    // History Data
    const [openHistoryModal, setOpenHistoryModal] = useState(false);
    const [historyData, setHistoryData] = useState(undefined);
    const [historyField, setHistoryField] = useState(undefined);
    const [urlVal, setUrlVal] = useState("")

    const [open, setOpen] = useState(false);
    // Profile data
    const [employeeImage, setEmployeeImage] = useState('');
    const [imageProfile, setImageProfile] = useState(null)
    const [cropingModalOpen, setCropingModalOpen] = useState(false);
    const [mainUuid, setMainUuid] = useState('');
    const [mainCategory, setMainCategory] = useState('');
    const [profileSrc, setProfileSrc] = useState('')

    const [departmentEmpty, setDepartmentEmpty] = useState(false);
    const [designationEmpty, setDesignationEmpty] = useState(false);
    const [sourceHiringEmpty, setSourceHiringEmpty] = useState(false);
    const [workLocationEmpty, setWorkLocationEmpty] = useState(false);
    const [citizenshipEmpty, setCitizenshipEmpty] = useState(false);
    const [isSubmitForm, setIsSubmitForm] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm()
    useEffect(() => {
        if (historyData) {
            setOpenHistoryModal(true);
        }
    }, [historyData]);
    useEffect(() => {
        if (!openHistoryModal) {
            setHistoryData(undefined);
            setHistoryField(undefined);
        }
    }, [openHistoryModal]);
    // History Data Ends
    const [uploadingSteps, setUploadingSteps] = useState([
        {
            name: "Uploading Employment Contract",
            status: "pending",
        },
        {
            name: "Uploading Skill Qualification",
            status: "pending",
        },
        {
            name: "Uploading Recruitment Process",
            status: "pending",
        },
        {
            name: "Uploading Right To Work",
            status: "pending",
        },
        {
            name: "Uploading Other Documents",
            status: "pending",
        },
        {
            name: `${mode === "create" ? "Creating" : "Updating"} Employee`,
            status: "pending",
        }
    ]);

    const getMainUnuid = async () => {
        let uuid = null;
        if (mode === "create") {
            const resp = await Axios.post("/employee/get-id", {})
            uuid = resp.data.uuid;
            setMainUuid(resp.data.uuid)
        }
        else {
            uuid = location.pathname.split("/").pop();
            setMainUuid(uuid)
        }
    };

    const typesOfVisaArray = [
        'notApplicable',
        'studentVisa',
        'employmentVisa',
        'businessVisa',
        'projectVisa'
    ]
    let keepOriginalVisaType = ""

    useEffect(() => {
        if (mode === "edit") {
            setLoading(true);
            setHideExtraLoading(true);
            const uid = location.pathname.split("/").pop();
            employeeStore.getEmployeeInfo(uid).then((response) => {
                if (response.error) {
                    navigate("/404");
                }
                if (!(typesOfVisaArray.includes(response.data.typeOfVisa) )) {
                    keepOriginalVisaType = response.data.typeOfVisa
                    console.log("response.data.typeOfVisa.1", response.data.typeOfVisa)
                    response.data.typeOfVisa = "otherVisa"
                    console.log("response.data.typeOfVisa.2", response.data.typeOfVisa)
                    response.data.visaInputBox = keepOriginalVisaType
                    setShowVisaInputBox(true)
                }
                setData(response.data);
                const skipKeys = [
                    '_id',
                    'created_at',
                    'updated_at',
                    'uuid',
                    'workingDays',
                    'leaveSettings',
                    'employementContract',
                    'skillQualification',
                    'recruitmentProcess',
                    'rightToWork',
                    'otherDocuments',
                    'company_uuid',
                ];
                
                Object.entries(response.data).forEach(([key, value]) => {
                    if (skipKeys.includes(key)) return;
                    if (typeof value === 'object' && value !== null) return; // skip arrays & objects
                    setValue(key, value);
                });
                setEmployeeImage(response.data.imageProfile)
                setValue('firstName', response.data.firstName)
                setValue('lastName', response.data.lastName)
                setValue('dob', response.data.dob)
                setValue('personalEmail', response.data.personalEmail)
                setValue('email', response.data.email)
                setValue('phone', response.data.phone)
                setValue('address', response.data.address)
                setValue('additionalNotes', response.data.additionalNotes)
                setValue('niNum', response.data.niNum)
                setValue('jobStartDate', response.data.jobStartDate)
                setValue('typeOfVisa', response.data.typeOfVisa)
                setValue('status',response.data.status)
                // setValue('visaInputBox', keepOriginalVisaType)
                setLoading(false);
                setHideExtraLoading(false);
            });
        }

        getMainUnuid();
    }, []);


    const uploadFiles = async (_files, uuid, category) => {
        const data = new FormData();
        for (let i = 0; i < _files.length; i++) {
            data.append("files", _files[i]);
        }
        data.append("uuid", uuid);
        data.append("category", category);
        try {
            const res = await Axios({
                method: "POST",
                url: "/upload",
                data: data,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (res.data.success)
                return {
                    category,
                    files: res.data.files,
                }
        } catch (error) {
            return {
                category,
                files: [],
            }
        }
    }


    useEffect(() => {
        if (imageProfile) {
            setMainCategory("imageProfile");
        }
    }, [imageProfile])

    useEffect(() => {
        if (department) {
            setDepartmentEmpty(false);
        } else {
            setDepartmentEmpty(true);
        }

        if (designation) {
            setDesignationEmpty(false);
        } else {
            setDesignationEmpty(true);
        }

        if (sourceOfHiring) {
            setSourceHiringEmpty(false);
        } else {
            setSourceHiringEmpty(true);
        }

        if (workLocation) {
            setWorkLocationEmpty(false);
        } else {
            setWorkLocationEmpty(true);
        }

        if (citizenship) {
            setCitizenshipEmpty(false);
        } else {
            setCitizenshipEmpty(true);
        }

    }, [department,designation,sourceOfHiring,workLocation,citizenship])

    const handleFiles = async (uuid) => {
        let filesData = {};
        // if (imageProfile && imageProfile.length > 0) {
        //     let resp = await imageUploadFiles(imageProfile, uuid, "imageProfile");
        //     filesData["imageProfile"] = resp.files;
        //     setUploadingSteps((prev) => {
        //         let newState = [...prev];
        //         newState[0].status = "done";
        //         return newState;
        //     })
        //     if (mode === "edit") {
        //         if (data.imageProfile && data.imageProfile.length > 0) {
        //             filesData["imageProfile"] = [...data.imageProfile, ...filesData["imageProfile"]];
        //         }
        //     }
        // }
        // else {
        //     if (mode === "edit") {
        //         if (data.imageProfile && data.imageProfile.length > 0) {
        //             filesData["imageProfile"] = data.imageProfile;
        //         }
        //     }
        // }
        if (employementContract && employementContract.length > 0) {
            let resp = await uploadFiles(employementContract, uuid, "employementContract");
            filesData["employementContract"] = resp.files;
            setUploadingSteps((prev) => {
                let newState = [...prev];
                newState[0].status = "done";
                return newState;
            })
            if (mode === "edit") {
                if (data.employementContract && data.employementContract.length > 0) {
                    filesData["employementContract"] = [...data.employementContract, ...filesData["employementContract"]];
                }
            }
        }
        else {
            if (mode === "edit") {
                if (data.employementContract && data.employementContract.length > 0) {
                    filesData["employementContract"] = data.employementContract;
                }
                else filesData["employementContract"] = []
            }
        }
        if (skillQualification && skillQualification.length > 0) {
            let resp = await uploadFiles(skillQualification, uuid, "skillQualification");
            filesData["skillQualification"] = resp.files;
            setUploadingSteps((prev) => {
                let newState = [...prev];
                newState[1].status = "done";
                return newState;
            })
            if (mode === "edit") {
                if (data.skillQualification && data.skillQualification.length > 0) {
                    filesData["skillQualification"] = [...data.skillQualification, ...filesData["skillQualification"]];
                }
            }
        }
        else {
            if (mode === "edit") {
                if (data.skillQualification && data.skillQualification.length > 0) {
                    filesData["skillQualification"] = data.skillQualification;
                }
                else filesData["skillQualification"] = []
            }
        }
        if (recruitmentProcess && recruitmentProcess.length > 0) {
            let resp = await uploadFiles(recruitmentProcess, uuid, "recruitmentProcess");
            filesData["recruitmentProcess"] = resp.files;
            setUploadingSteps((prev) => {
                let newState = [...prev];
                newState[2].status = "done";
                return newState;
            })
            if (mode === "edit") {
                if (data.recruitmentProcess && data.recruitmentProcess.length > 0) {
                    filesData["recruitmentProcess"] = [...data.recruitmentProcess, ...filesData["recruitmentProcess"]];
                }
            }
        }
        else {
            if (mode === "edit") {
                if (data.recruitmentProcess && data.recruitmentProcess.length > 0) {
                    filesData["recruitmentProcess"] = data.recruitmentProcess;
                }
                else filesData["recruitmentProcess"] = []
            }
        }
        if (rightToWork && rightToWork.length > 0) {
            let resp = await uploadFiles(rightToWork, uuid, "rightToWork");
            filesData["rightToWork"] = resp.files;
            setUploadingSteps((prev) => {
                let newState = [...prev];
                newState[3].status = "done";
                return newState;
            })
            if (mode === "edit") {
                if (data.rightToWork && data.rightToWork.length > 0) {
                    filesData["rightToWork"] = [...data.rightToWork, ...filesData["rightToWork"]];
                }
            }
        }
        else {
            if (mode === "edit") {
                if (data.rightToWork && data.rightToWork.length > 0) {
                    filesData["rightToWork"] = data.rightToWork;
                }
                else filesData["rightToWork"] = []
            }
        }
        if (otherDocuments && otherDocuments.length > 0) {
            let resp = await uploadFiles(otherDocuments, uuid, "other");
            filesData["otherDocuments"] = resp.files;
            setUploadingSteps((prev) => {
                let newState = [...prev];
                newState[4].status = "done";
                return newState;
            })
            if (mode === "edit") {
                if (data.otherDocuments && data.otherDocuments.length > 0) {
                    filesData["otherDocuments"] = [...data.otherDocuments, ...filesData["otherDocuments"]];
                }
            }
        }
        else {
            if (mode === "edit") {
                if (data.otherDocuments && data.otherDocuments.length > 0) {
                    filesData["otherDocuments"] = data.otherDocuments;
                }
                else filesData["otherDocuments"] = []
            }
        }
        return filesData;
    }

    // console.log(errors, "errorsss")
    const createEmployee = async (target) => {
        // onClick={()=> setIsSubmitForm(true)}
        // setIsSubmitForm(true)
        // console.log("aaaaaaaaaaaaa")
        // const form = new FormData(target);
        // const values = Object.fromEntries(form.entries());
        const values = target;
        console.log("__VAL__", values)
        // let uuid = null;
        // setLoading(true);

        // if (mode === "create") {
        //     const resp = await Axios.post("/employee/get-id", {})
        //     uuid = resp.data.uuid;
        //     console.log(uuid, "uuiduuiduuid")
        // }
        // else {
        //     uuid = location.pathname.split("/").pop();
        // }

        if (department === null) {
            layoutStore.showToaster("Please select department", "error");
            setLoading(false);
            return;
        }
        if (designation === null) {
            layoutStore.showToaster("Please select designation", "error");
            setLoading(false);
            return;
        }
        if (sourceOfHiring === null) {
            layoutStore.showToaster("Please select source of hiring", "error");
            setLoading(false);
            return;
        }
        if (workLocation === null) {
            layoutStore.showToaster("Please select work location", "error");
            setLoading(false);
            return;
        }
        if (citizenship === null) {
            layoutStore.showToaster("Please select citizenship", "error");
            setLoading(false);
            return;
        }
        if (mode === "create") {
            const isEmailAvailable = await checkEmailAvailibilty(false);
            if (!isEmailAvailable) {
                layoutStore.showToaster("Official email is already taken", "error");
                setLoading(false);
                return;
            }
        }
        // Get values from form

        const files = await handleFiles(mainUuid);
        if (!numberOfLeaves) {
            layoutStore.showToaster(`Number of leaves is required`, "error");
            setLoading(false);
            return
        }
        const leaveSettings = {
            days: parseInt(numberOfLeaves),
            timePeriod: timePeriod
        }
        if (timePeriod === "yearly") {
            leaveSettings.startMonth = startMonth;
        }

        let employee = {
            uuid: mainUuid,
            imageProfile: employeeImage || "",
            department,
            designation,
            workLocation,
            sourceOfHiring,
            citizenship,
            workingDays: enabled.map((day, idx) => day ? days[idx] : null).filter((day) => day),
            leaveSettings,
            ...files,
            ...values,
        }
        if (mode === "create") {
            Axios.post("/employee/create", employee).then((res) => {
                if (res.data.success) {
                    setUploadingSteps((prev) => {
                        let newState = [...prev];
                        newState[5].status = "done";
                        return newState;
                    })
                    layoutStore.showToaster("Employee created successfully", "success");
                    navigate("/employees");
                }
                else {
                    layoutStore.showToaster(res.data.error, "error");
                    setLoading(false);
                }
            }).catch((err) => {
                layoutStore.showToaster("Something went wrong", "error");
                setLoading(false);
            });
        }
        else {
            Axios.post("/employee/update", employee).then((res) => {
                if (res.data.success) {
                    setUploadingSteps((prev) => {
                        let newState = [...prev];
                        newState[5].status = "done";
                        return newState;
                    })
                    layoutStore.showToaster("Employee edited successfully", "success");
                    // setTimeout(() => {
                    //     window.location.reload();
                    // }, 1000);
                    navigate("/employees");
                }
                else {
                    layoutStore.showToaster(res.data.error, "error");
                    setLoading(false);
                }
            }).catch((err) => {
                layoutStore.showToaster("Something went wrong", "error");
                setLoading(false);
            });
        }

    }
    const updateDataFiles = (files, category) => {
        const prev = { ...data };
        prev[category] = files;
        setData(prev);
    }
    const checkEmailAvailibilty = async (showToaster = true) => {
        setOfficialEmailText("Checking...");
        const resp = await Axios.post("/employee/check-email", { email: officialEmail });
        if (resp.data.exists) {
            if (showToaster)
                layoutStore.showToaster("Official Email already exists", "error");
            setOfficialEmailText("Check Availability");
            return false;
        }
        if (resp.data.error) {
            if (showToaster)
                layoutStore.showToaster("Something went wrong", "error");
            setOfficialEmailText("Check Availability");
            return false;
        }
        if (showToaster)
            layoutStore.showToaster("Official Email is available", "success");
        setOfficialEmailText("Check Availability");
        return true;
    }
    const handleChangeOfficialEmail = (data) => {
        if (data.match(regex.regexForEmail)) {
            setOfficialEmail(data)
        }
        else {
            setOfficialEmail(null)
        }
    }
    const goBackButton = () => {
        // router.back()
        navigate('/employees')
    }

    useEffect(() => {
        setLoading(true)

        if (mode === "create") {
            Axios.post("/company/leave-settings/get", {}).then((res) => {
                const data = res.data;
                if (data.workingDays) {
                    let workingDays = [];
                    days.forEach((day, idx) => {
                        workingDays.push(data.workingDays.includes(day));
                    });
                    setEnabled(workingDays);
                }
                if (data.leaveSettings) {
                    if (data.leaveSettings.days)
                        setNumberOfLeaves(data.leaveSettings.days);
                    if (data.leaveSettings.timePeriod)
                        setTimePeriod(data.leaveSettings.timePeriod);
                        if (data.leaveSettings.timePeriod === "yearly"){
                        setStartMonth(data.leaveSettings.startMonth)
                    }
                }
                setLoading(false);
            })
        } else {

            Axios.post("/employee/leave-settings/get", { "employee_uuid": location.pathname.split("/").pop() }).then((res) => {
                const data = res.data;
                console.log("employee/leave-settings", data)
                if (data.workingDays) {
                    let workingDays = [];
                    days.forEach((day, idx) => {
                        workingDays.push(data.workingDays.includes(day));
                    });
                    setEnabled(workingDays);
                }
                if (data.leaveSettings) {
                    if (data.leaveSettings.days)
                        setNumberOfLeaves(data.leaveSettings.days);
                    if (data.leaveSettings.timePeriod)
                        setTimePeriod(data.leaveSettings.timePeriod);
                        if (data.leaveSettings.timePeriod === "yearly"){
                        setStartMonth(data.leaveSettings.startMonth)
                    }
                }
                setLoading(false);
            })
        }

    }, []);

    const handleVisa = (data) => {
        console.log("VISA", data)
        setValue('typeOfVisa', data)

        if (data == "otherVisa"){
            // setOtherVisa(true)
            setShowVisaInputBox(true)
        } else{
            setShowVisaInputBox(false)
        }
    }

    return (
        <>
            {loading &&
                <div>
                    <Loader />
                    {!hideExtraLoading &&
                        <div className="fixed   w-full h-full top-1/4 font-bold">
                            <p className="text-xl bg-white">
                                Please wait this might take a while <br />
                                Don't close this tab
                            </p>
                            <ul className="p-4 rounded bg-white">
                                {uploadingSteps.map((step, index) => (
                                    <li key={index} className="flex justify-between items-center font-semibold">
                                        {step.status === "pending" ? "🕒" : "✅"}
                                        {step.name}
                                    </li>
                                ))}
                            </ul>
                        </div>}
                </div>
            }
            <button
                type="button"
                onClick={goBackButton}
                className="mb-6 inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
                Back
            </button>
            <div className="bg-white shadow sm:rounded-lg p-4">

                <div className="py-5">
                    <h2 className="text-2xl font-bold leading-6 text-gray-800 border-b pb-4">
                        {
                            mode === "edit" ? "Edit Employee" : "Create New Employee"
                        }
                    </h2>
                </div>
                <form
                    // onSubmit={(e) => {
                    //     e.preventDefault();
                    //     createEmployee(e.target);
                    // }}
                    onSubmit={handleSubmit(createEmployee)}
                >
                    {/* Basic Information */}
                    <FormContainer
                        title={"Personal Information"}
                        description={"The Official Email will be used to login to the system and can't be changed"}
                    >

                        <div>
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-gray-700">
                                    Profile Image
                                </label>
                            </div>
                            <div className="block justify-between mt-3 w-100 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                                <ImageFileUpload
                                    key={JSON.stringify(data.imageProfile)}
                                    setParent={setImageProfile}
                                    employeeImage={employeeImage}
                                    updateParent={(files) => {
                                        updateDataFiles(files, "imageProfile");
                                    }}
                                    previousFiles={data.imageProfile ? data.imageProfile : []}
                                    setUrlVal={setUrlVal}
                                    setOpen={setOpen}
                                    setCropingModalOpen={setCropingModalOpen}
                                    setProfileSrc={setProfileSrc}
                                />

                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
                                    First Name
                                    <span className="asterisk">*</span>
                                </label>

                            </div>
                            <div className="mt-1">
                                <input
                                    type="text"
                                    name="firstName"
                                    defaultValue={data.firstName}
                                    placeholder="John"
                                    className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    {...register("firstName", { required: true, pattern: regex.regexForName })}
                                />
                                {errors.firstName && (errors.firstName.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter only alphabets</span>)}
                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
                                    Last Name
                                    <span className="asterisk">*</span>
                                </label>

                            </div>
                            <div className="mt-1">
                                <input
                                    type="text"
                                    name="lastName"
                                    defaultValue={data.lastName}
                                    placeholder="Doe"
                                    className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    {...register("lastName", { required: true, pattern: regex.regexForName })}
                                />
                                {errors.lastName && (errors.lastName.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter only alphabets</span>)}
                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="dob" className="block text-sm font-medium text-gray-700">
                                    Date of Birth
                                    <span className="asterisk">*</span>
                                </label>

                            </div>
                            <div className="mt-1">
                                <input
                                    type="date"
                                    name="dob"
                                    defaultValue={data.dob}
                                    min={dob_min + '-' + now_month + '-' + now_date}
                                    max={dob_max + '-' + now_month + '-' + now_date}
                                    className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    {...register("dob", { required: true })}
                                />
                                {errors.dob && <span className="error-message">This field is required</span>}
                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="personalEmail" className="block text-sm font-medium text-gray-700">
                                    Personal Email
                                    <span className="asterisk">*</span>
                                </label>

                            </div>
                            <div className="mt-1">
                                <input
                                    type="text"
                                    name="personalEmail"
                                    defaultValue={data.personalEmail}
                                    placeholder="john@gmail.com"
                                    className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    {...register("personalEmail", { required: true, pattern: regex.regexForEmail })}
                                />
                                {errors.personalEmail && (errors.personalEmail.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter a valid Email ID</span>)}
                            </div>
                            {
                                mode === "edit" &&
                                <>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setHistoryField({
                                                "name": "personalEmail",
                                                "displayName": "Personal Email",
                                            });
                                            setHistoryData(data.personalEmail);
                                        }}
                                        className="inline-flex items-center rounded border border-gray-300 bg-white mt-2 px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                    >
                                        Add Record To Employee History
                                    </button>
                                    <div>
                                        <span className="text-xs">
                                            Disclaimer: Please click on "Add Record To Employee History" before overwriting any contact details
                                        </span>
                                    </div>
                                </>
                            }
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                    Official Email
                                    <span className="asterisk">*</span>
                                </label>

                            </div>
                            <div className="mt-1">
                                <input
                                    type="text"
                                    name="email"
                                    defaultValue={data.email}
                                    disabled={mode === "edit"}
                                    placeholder="john@domain.com"
                                    className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    onKeyDown={(e) => { handleChangeOfficialEmail(e.target.value) }}
                                    onChange={(e) => { handleChangeOfficialEmail(e.target.value) }}
                                    {...register("email", { required: true, pattern: regex.regexForEmail })}

                                />
                                {errors.email && (errors.email.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter a valid Email ID</span>)}
                            </div>
                            <button
                                type="button"
                                disabled={!officialEmail || officialEmailText === "Checking..."}
                                onClick={() => { checkEmailAvailibilty() }}
                                className="mt-2 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                            >
                                {officialEmailText}
                            </button>
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                                    Phone Number
                                    <span className="asterisk">*</span>
                                </label>

                            </div>
                            <div className="mt-1">
                                <input
                                    type="tel"
                                    name="phone"
                                    defaultValue={data.phone}
                                    placeholder="+447222555555"
                                    className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    // Add regex for UK phone number, It should start with +44
                                    // pattern="((\+44(\s\(0\)\s|\s0\s|\s)?)|0)7\d{3}(\s)?\d{6}"
                                    {...register("phone", { required: true, pattern: regex.regexForPhone, maxLength: 25 })}
                                />
                                {errors.phone && (errors.phone.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter a valid Phone No.</span>)}
                            </div>
                            {
                                mode === "edit" &&
                                <>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setHistoryField({
                                                "name": "phone",
                                                "displayName": "Phone Number",
                                            });
                                            setHistoryData(data.phone);
                                        }}
                                        className="inline-flex items-center rounded border border-gray-300 hover:border-blue-500 bg-white mt-2 px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                    >
                                        Add Record To Employee History
                                    </button>
                                    <div>
                                        <span className="text-xs">
                                            Disclaimer: Please click on "Add Record To Employee History" before overwriting any contact details
                                        </span>
                                    </div>
                                </>
                            }
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="alternatePhone" className="block text-sm font-medium text-gray-700">
                                    Alternate Phone Numbers
                                </label>

                            </div>
                            <div className="mt-1">
                                <input
                                    type="text"
                                    name="alternatePhone"
                                    defaultValue={data.alternatePhone}
                                    placeholder="555-555-5555, 444-444-5555"
                                    className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                />
                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="address" className="block text-sm font-medium text-gray-700">
                                    Address
                                    <span className="asterisk">*</span>
                                </label>

                            </div>
                            <div className="mt-1">
                                <textarea
                                    name="address"
                                    defaultValue={data.address}
                                    placeholder="1234 Main St"
                                    className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm resize-none"
                                    {...register("address", { required: true, pattern: regex.regexForAddress })}
                                />
                                {errors.address && (errors.address.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter a valid Address</span>)}
                            </div>
                            {
                                mode === "edit" &&
                                <>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setHistoryField({
                                                "name": "address",
                                                "displayName": "Address",
                                            });
                                            setHistoryData(data.address);
                                        }}
                                        className="inline-flex items-center rounded border border-gray-300 bg-white mt-2 px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                    >
                                        Add Record To Employee History
                                    </button>
                                    <div>
                                        <span className="text-xs">
                                            Disclaimer: Please click on "Add Record To Employee History" before overwriting any contact details
                                        </span>
                                    </div>
                                </>
                            }
                        </div>
                    </FormContainer>
                    {/* Professional Information */}
                    <FormContainer
                        title={"Professional Information"}
                        description={"Details about the employee's involvement in the company"}
                    >
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="status" className="block text-sm font-medium text-gray-700">
                                    Status
                                </label>

                            </div>
                            <div className="mt-1">
                                <select
                                    // id="companySize"
                                    // name="status"
                                    id="status"
                                    name="status"
                                        defaultValue= {data.status}
                                    className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                    {...register("status")}
                                >
                                    <option>Active</option>
                                    <option>Inactive</option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="Department" className="block text-sm font-medium text-gray-700">
                                    Department
                                    <span className="asterisk">*</span>
                                </label>

                            </div>
                            <div className="mt-1 border border-0.5 border-gray-300 hover:border-blue-500 rounded-md">
                                <SelectAndCreate
                                    name={"department"}
                                    optionAPI={"/company/department/get"}
                                    createAPI={"/company/department/create"}
                                    setParent={setDepartment}
                                    key={data.department}
                                    defaultValue={data.department}
                                />
                            </div>
                            {departmentEmpty && isSubmitForm && (<span className="error-message">This field is required</span>)}
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="Designation" className="block text-sm font-medium text-gray-700">
                                    Designation
                                    <span className="asterisk">*</span>
                                </label>

                            </div>
                            <div className="mt-1 border border-0.5 border-gray-300 hover:border-blue-500 rounded-md">
                                <SelectAndCreate
                                    name={"designation"}
                                    optionAPI={"/company/designation/get"}
                                    createAPI={"/company/designation/create"}
                                    setParent={setDesignation}
                                    key={data.designation}
                                    defaultValue={data.designation}
                                // {...register("designation", { required: true })}
                                />
                            </div>
                            {designationEmpty && isSubmitForm && (<span className="error-message">This field is required</span>)}
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-gray-700">
                                    Source Of Hiring
                                    <span className="asterisk">*</span>
                                </label>

                            </div>
                            <div className="mt-1 border border-0.5 border-gray-300 hover:border-blue-500 rounded-md">
                                <SelectAndCreate
                                    optionAPI={"/company/source-of-hiring/get"}
                                    createAPI={"/company/source-of-hiring/create"}
                                    setParent={setSourceOfHiring}
                                    key={data.sourceOfHiring}
                                    defaultValue={data.sourceOfHiring}
                                />
                            </div>
                            {sourceHiringEmpty && isSubmitForm && (<span className="error-message">This field is required</span>)}
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-gray-700">
                                    Work Location
                                    <span className="asterisk">*</span>
                                </label>

                            </div>
                            <div className="mt-1 border border-0.5 border-gray-300 hover:border-blue-500 rounded-md">
                                <SelectAndCreate
                                    optionAPI={"/company/work-location/get"}
                                    createAPI={"/company/work-location/create"}
                                    setParent={setWorkLocation}
                                    key={data.workLocation}
                                    defaultValue={data.workLocation}
                                />
                            </div>
                            {workLocationEmpty && isSubmitForm && (<span className="error-message">This field is required</span>)}
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-gray-700">
                                    Citizenship
                                    <span className="asterisk">*</span>
                                </label>

                            </div>
                            <div className="mt-1 border border-0.5 border-gray-300 hover:border-blue-500 rounded-md">
                                <SelectAndCreate
                                    optionAPI={"/company/citizenship/get"}
                                    createAPI={"/company/citizenship/create"}
                                    setParent={setCitizenship}
                                    key={data.citizenship}
                                    defaultValue={data.citizenship}
                                />
                            </div>
                            {citizenshipEmpty && isSubmitForm && (<span className="error-message">This field is required</span>)}
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="salary" className="block text-sm font-medium text-gray-700">
                                    Salary
                                </label>

                            </div>
                            <div className="mt-1">
                                <input
                                    type="number"
                                    name="salary"
                                    defaultValue={data.salary}
                                    placeholder="100000"
                                    min={0}
                                    className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    {...register("salary")}
                                />
                            </div>
                        </div>
                        {
                            !loading &&
                            <div>
                                <div className="flex justify-between">
                                    <label htmlFor="paidPer" className="block text-sm font-medium text-gray-700">
                                        Payment Frequency
                                        <span className="asterisk">*</span>
                                    </label>

                                </div>
                                <div className="mt-1">
                                    <select
                                        id="paidPer"
                                        name="paidPer"
                                        defaultValue={data.paidPer}
                                        className="mt-1 block w-full rounded-md border-gray-300 hover:border-blue-500 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                        {...register("paidPer")}
                                    >
                                        <option value="hourly">Hourly</option>
                                        <option value="daily">Daily</option>
                                        <option value="weekly">Weekly</option>
                                        <option value="monthly">Monthly</option>
                                        <option value="yearly">Yearly</option>
                                    </select>
                                </div>
                            </div>
                        }
                        {
                            !loading &&
                            <div>
                                <div className="flex justify-between">
                                    <label htmlFor="isSponsored" className="block text-sm font-medium text-gray-700">
                                        Is Sponsored Migrant?
                                        <span className="asterisk">*</span>
                                    </label>

                                </div>
                                <div className="mt-1">
                                    <select
                                        id="isSponsored"
                                        name="isSponsored"
                                        defaultValue={data.isSponsored}
                                        className="mt-1 block w-full rounded-md border-gray-300 hover:border-blue-500 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                        {...register("isSponsored")}
                                    >
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </select>
                                </div>
                            </div>
                        }
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="niNum" className="block text-sm font-medium text-gray-700">
                                    National Insurance Number
                                    {/* <span className="asterisk">*</span> */}
                                </label>

                            </div>
                            <div className="mt-1">
                                <input
                                    type="text"
                                    name="niNum"
                                    defaultValue={data.niNum}
                                    placeholder="AB123456C"
                                    // maxLength={50}
                                    className="block uppercase w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    // pattern="^\s*[a-zA-Z]{2}(?:\s*\d\s*){6}[a-dA-D]{1}?\s*$"
                                    // {...register("niNum", { required: true, regex.regexForNatInsuranceNum })}
                                    {...register("niNum", { maxLength: 50, pattern: regex.regexForNatInsuranceNum })}
                                />
                                {/* {errors.niNum && (errors.niNum.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter a valid National Insurance Number</span>)} */}
                                {errors.niNum && (errors.niNum.type === 'pattern' ? <span className="error-message">Only Alphanumerics, dash & space is allowed</span> : <span className="error-message">National Insurance Number exceeds 50 character limit</span>)}
                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="jobStartDate" className="block text-sm font-medium text-gray-700">
                                    Job Start Date
                                    <span className="asterisk">*</span>
                                </label>

                            </div>
                            <div className="mt-1">
                                <input
                                    type="date"
                                    name="jobStartDate"
                                    defaultValue={data.jobStartDate}
                                    placeholder="2021-01-01"
                                    min={past_100_year + '-' + now_month + '-' + now_date}
                                    max={next_year + '-' + now_month + '-' + now_date}
                                    className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    {...register("jobStartDate", { required: true })}
                                />
                                {errors.jobStartDate && <span className="error-message">This field is required</span>}
                            </div>
                        </div>
                        {
                            !loading &&
                            <>
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="typeOfVisa" className="block text-sm font-medium text-gray-700">
                                            Type of Visa
                                            {/* <span className="asterisk">*</span> */}
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <select
                                            id="typeOfVisa"
                                            name="typeOfVisa"
                                            defaultValue={data.typeOfVisa}
                                            onChange = {(e) => {
                                                handleVisa(e.target.value)
                                            }}

                                            className="mt-1 block w-full rounded-md border-gray-300 hover:border-blue-500 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                        // {...register("typeOfVisa")}
                                        >
                                            <option value="notApplicable">Not Applicable</option>
                                            <option value="studentVisa">Student Visa</option>
                                            <option value="employmentVisa">Employment Visa</option>
                                            <option value="businessVisa">Business Visa</option>
                                            <option value="projectVisa">Project Visa</option>
                                            <option value="otherVisa">Other Visa</option>
                                        </select>
                                    </div>
                                </div>

                                {showVisaInputBox  &&
                                    <div className="mt-1">
                                        <div className="flex justify-between">
                                            <label htmlFor="typeOfVisa" className="block text-sm font-medium text-gray-700">
                                                Please specify
                                                <span className="asterisk">*</span>
                                            </label>
                                        </div>
                                        <div className="mt-1">
                                            <input
                                                type="text"
                                                name="visaInputBox"
                                                defaultValue={data.visaInputBox}
                                                placeholder="Enter the visa type"
                                                className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                                {...register("visaInputBox", { required: true, maxLength: 64, pattern: regex.regexForCustomVisa })}
                                            />
                                            { errors.visaInputBox && (errors.visaInputBox.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter valid visa type/name</span>)}
                                            {/* {errors.phone && (errors.phone.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter a valid Phone No.</span>)} */}
                                        </div>
                                    </div>
                                }
                            </>
                        }
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="visaExpiresDate" className="block text-sm font-medium text-gray-700">
                                    Visa Expiry Date
                                </label>


                            </div>
                            <div className="mt-1">
                                {console.log("data.visaExpiresDate", data.visaExpiresDate, (data.visaExpiresDate)?.slice(8,))}
                                {console.log("data.visaExpiresDate", (data.visaExpiresDate)?.slice(8,) + '-' + (data.visaExpiresDate)?.slice(5, 7) + '-' + (data.visaExpiresDate)?.slice(0, 4))}
                                <input
                                    type="date"
                                    name="visaExpiresDate"
                                    defaultValue={data.visaExpiresDate}
                                    min={mode === "edit" ? ((two_days_in_future.getFullYear()).toString() + '-' + ('0' + (two_days_in_future.getMonth() + 1).toString()).slice(-2) + '-' + ('0' + (two_days_in_future.getDate()).toString()).slice(-2)) : ((two_days_in_future.getFullYear()).toString() + '-' + ('0' + (two_days_in_future.getMonth() + 1).toString()).slice(-2) + '-' + ('0' + (two_days_in_future.getDate()).toString()).slice(-2))}
                                    max={mode === "edit" ? (next_ten_year + '-' + now_month + '-' + now_date) : (next_ten_year + '-' + now_month + '-' + now_date)}
                                    placeholder="2021-01-01"
                                    className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    {...register("visaExpiresDate")}
                                />
                                {/* { errors.visaExpiresDate && showVisaInputBox && (errors.visaExpiresDate.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message"></span>)} */}
                            </div>
                        </div>
                        {/* <div>
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-gray-700">
                                    Reports To
                                </label>

                            </div>
                            <div className="mt-1">
                                <Search
                                    setParent={(value) => setManager(value.uuid)}
                                    apiURL={"/employee/search"}
                                    defaultValue={data.manager}
                                />
                            </div>
                        </div> */}
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="additionalNotes" className="block text-sm font-medium text-gray-700">
                                    Additional Notes
                                </label>
                            </div>
                            <div className="mt-1">
                                <textarea
                                    name="additionalNotes"
                                    defaultValue={data.additionalNotes}
                                    placeholder="Is There Anything Else We Should Know About?"
                                    className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm resize-none"
                                    {...register("additionalNotes", { maxLength: 200 })}
                                />
                                {errors.additionalNotes && (errors.additionalNotes.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Note exceeds 200 character limit</span>)}
                            </div>
                        </div>
                    </FormContainer>
                    {/* {loading && <Loader />} */}
                    <FormContainer title="Working Days" description="Select the working days for your company. Employees won't be able to mark their attendance on non-working days">
                        {days.map((day, dayIdx) => (
                            <Switch.Group as="div" className="flex inline items-center" key={dayIdx}>
                                <Switch
                                    checked={enabled[dayIdx]}
                                    onChange={() => {
                                        const newEnabled = [...enabled]
                                        newEnabled[dayIdx] = !newEnabled[dayIdx]
                                        setEnabled(newEnabled)
                                    }}
                                    className={classNames(
                                        enabled[dayIdx] ? 'bg-blue-600' : 'bg-gray-200',
                                        'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
                                    )}
                                >
                                    <span
                                        aria-hidden="true"
                                        className={classNames(
                                            enabled[dayIdx] ? 'translate-x-5' : 'translate-x-0',
                                            'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                                        )}
                                    />
                                </Switch>
                                <Switch.Label as="span" className="ml-3">
                                    <span className="text-sm font-medium text-gray-900">{day}</span>
                                </Switch.Label>
                            </Switch.Group>
                        ))}
                    </FormContainer>
                    <FormContainer title="Available Leaves" description="Select Leave Tenure and Number Of Leaves Allocated/Tenure">
                        <div>
                            <div className="flex justify-between">
                                <label htmlFor="numberOfLeaves" className="block text-sm font-medium text-gray-700">
                                    Number of Leaves
                                </label>

                            </div>
                            <div className="mt-1">
                                <input
                                    type="number"
                                    name="numberOfLeaves"
                                    placeholder="0.00"
                                    onChange={(e) => {
                                        setNumberOfLeaves(e.target.value)
                                    }}
                                    // min={0}
                                    value={numberOfLeaves}
                                    className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    required
                                // {...register("numberOfLeaves", { min: 0 })}
                                />
                                {/* {errors.numberOfLeaves && (<span className="error-message">Enter valid number of leaves</span>)} */}
                            </div>
                        </div>
                        <div>
                            {
                                !loading &&
                                <>
                                    <div>
                                        <div className="flex justify-between">
                                            <label htmlFor="leaveTenure" className="block text-sm font-medium text-gray-700">
                                                Time Period
                                            </label>

                                        </div>
                                        <div className="mt-1">
                                            <select
                                                id="leaveTenure"
                                                name="leaveTenure"
                                                onChange={(e) => {
                                                    setTimePeriod(e.target.value)
                                                }}
                                                className="mt-1 block w-full rounded-md border-gray-300 hover:border-blue-500 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                                required
                                                value={timePeriod}
                                            >
                                                <option value="weekly">Weekly</option>
                                                <option value="monthly">Monthly</option>
                                                <option value="yearly">Yearly</option>
                                            </select>
                                        </div>
                                    </div>
                                    {timePeriod === "yearly" && (
                                        <div className='mt-3'>
                                            <div className="flex justify-between">
                                                <label htmlFor="startMonth" className="block text-sm font-medium text-gray-700">
                                                    Start Month For Leave Cycle
                                                </label>

                                            </div>
                                            <div className="mt-1">
                                                <select
                                                    id="startMonth"
                                                    name="startMonth"
                                                    onChange={(e) => {
                                                        setStartMonth(e.target.value)
                                                    }}
                                                    className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                                    required
                                                    value={startMonth}
                                                >
                                                    <option value={1} >January</option>
                                                    <option value={2} >February</option>
                                                    <option value={3} >March</option>
                                                    <option value={4} >April</option>
                                                    <option value={5} >May</option>
                                                    <option value={6} >June</option>
                                                    <option value={7} >July</option>
                                                    <option value={8} >August</option>
                                                    <option value={9} >September</option>
                                                    <option value={10} >October</option>
                                                    <option value={11} >November</option>
                                                    <option value={12} >December</option>
                                                </select>
                                            </div>
                                        </div>
                                    )}
                                </>
                            }
                        </div>
                    </FormContainer>


                    {/* Document Uploads */}
                    <FormContainer
                        title={"Employee Documents"}
                        description={"Only PDF files are allowed."}
                    >
                        <div>
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-gray-700">
                                    Employment Contract (signed by the employer and the employee)
                                </label>
                            </div>
                            <div className="block mt-3 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                                <FileUpload
                                    key={JSON.stringify(data.employementContract)}
                                    setParent={setEmployementContract}
                                    updateParent={(files) => {
                                        updateDataFiles(files, "employementContract");
                                    }}
                                    previousFiles={data.employementContract ? data.employementContract : []}
                                    setUrlVal={setUrlVal}
                                    setOpen={setOpen}
                                />
                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-gray-700">
                                    Skill Qualification/ Experience Document
                                </label>
                            </div>
                            <div className="block mt-3 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                                <FileUpload
                                    key={JSON.stringify(data.skillQualification)}
                                    setParent={setSkillQualification}
                                    updateParent={(files) => {
                                        updateDataFiles(files, "skillQualification");
                                    }}
                                    previousFiles={data.skillQualification ? data.skillQualification : []}
                                    setUrlVal={setUrlVal}
                                    setOpen={setOpen}
                                />
                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-gray-700">
                                    Recruitment Process Documents
                                </label>
                            </div>
                            <div className="block mt-3 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                                <FileUpload
                                    key={JSON.stringify(data.recruitmentProcess)}
                                    setParent={setRecruitmentProcess}
                                    updateParent={(files) => {
                                        updateDataFiles(files, "recruitmentProcess");
                                    }}
                                    previousFiles={data.recruitmentProcess ? data.recruitmentProcess : []}
                                    setUrlVal={setUrlVal}
                                    setOpen={setOpen}
                                />
                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-gray-700">
                                    Right To Work Document
                                </label>
                            </div>
                            <div className="block mt-3 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                                <FileUpload
                                    key={JSON.stringify(data.rightToWork)}
                                    setParent={setRightToWork}
                                    updateParent={(files) => {
                                        updateDataFiles(files, "rightToWork");
                                    }}
                                    previousFiles={data.rightToWork ? data.rightToWork : []}
                                    setUrlVal={setUrlVal}
                                    setOpen={setOpen}
                                />
                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between">
                                <label className="block text-sm font-medium text-gray-700">
                                    Others
                                </label>
                                <br />
                            </div>
                            <p className="text-sm text-gray-600">
                                Add a Job description for the role that should include the skills, qualifications, experience required for the role or any other Documents
                            </p>
                            <div className="block mt-3 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                                <FileUpload
                                    key={JSON.stringify(data.otherDocuments)}
                                    setParent={setOtherDocuments}
                                    updateParent={(files) => {
                                        updateDataFiles(files, "otherDocuments");
                                    }}
                                    previousFiles={data.otherDocuments ? data.otherDocuments : []}
                                    setUrlVal={setUrlVal}
                                    setOpen={setOpen}
                                />
                            </div>
                        </div>
                    </FormContainer>
                    <div className="text-right">
                        {
                            mode === "edit" &&
                            <button
                                type="button"
                                className="inline-flex mr-4 justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-gray-600 border border-gray-300 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                onClick={() => {
                                    navigate('/employees')
                                }}
                            >
                                Cancel
                            </button>
                        }
                        <button
                            type="submit"
                            onClick={()=> setIsSubmitForm(true)}
                            className="inline-flex ml-auto justify-center py-2 px-4 m-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            {mode === "create" ? "Create" : "Update"} Employee
                        </button>
                    </div>
                </form>
            </div>
            {
                mode === "edit" &&
                <CreateHistory
                    employee_uuid={location.pathname.split("/").pop()}
                    field={historyField}
                    value={historyData}
                    open={openHistoryModal}
                    setOpen={setOpenHistoryModal}
                />
            }
            <FileViewer url={urlVal} setOpen={setOpen} open={open} />
            {cropingModalOpen &&
                <ImageCropingViewer
                    src={profileSrc}
                    realProfile={imageProfile}
                    setCropingOpen={setCropingModalOpen}
                    open={cropingModalOpen}
                    mainUuid={mainUuid}
                    category={mainCategory}
                    setEmployeeImage={setEmployeeImage}
                />
            }
        </>
    )
}
export default CreateEmployee;
